// used to sleep
export const delay = async (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const runWithDelay = async <T> (promises: Array<() => Promise<T>>, delayMs: number): Promise<Array<T>> => {
    const results = [];
    for (const p of promises) {
        results.push(await p());
        await delay(delayMs);
    }
    return results;
};

